module.exports = __webpack_public_path__ + "media/configurations/ZOC_O-X-8a9c9182.png";